export default "__VITE_ASSET__9wZ_0$IA__"